global.$ = global.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';

window.bootstrap = bootstrap;

import AOS from 'aos';
import 'aos/dist/aos.css';

import {gsap} from "gsap";
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {SplitText} from 'gsap/SplitText';
import {Physics2DPlugin} from 'gsap/Physics2DPlugin';

gsap.registerPlugin([ScrollTrigger, SplitText]);
import Headroom from "headroom.js";

const Masonry = require('masonry-layout');

var $ = require('jquery');
var jQueryBridget = require('jquery-bridget');
var Isotope = require('isotope-layout');
// make Isotope a jQuery plugin
jQueryBridget('isotope', Isotope, $);

import './video';

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

window.Swiper = Swiper;

import fslightbox from "fslightbox";
import imagesLoaded from "imagesloaded";


$(document).ready(function () {
    let headerHeight;
    if (!isMobile()) {
        // let headerSubMenu = $(".submenu").outerHeight();
        // $(".submenu").outerHeight(headerHeight + headerSubMenu);
        headerHeight = $("header").outerHeight();
        $(".submenu").css("top", headerHeight);
    }

    // Sticky scroll Header
    if ($('header.headroom').length > 0) {
        let headroomEl = document.querySelector("header");
        let options = {
            onNotTop: function (mainEl) {
                document.querySelector("main").classList.add('main--has-scroll');
            },
            onTop: function (mainEl) {
                document.querySelector("main").classList.remove('main--has-scroll');
                if (!isMobile()) {
                    headerHeight = $("header").outerHeight();
                    $(".submenu").css("top", headerHeight);
                }
            },
            onPin: function () {
                if (!isMobile()) {
                    headerHeight = $("header").outerHeight();
                    $(".submenu").css("top", headerHeight);
                }
            },
            offset: 100,
        }
        var headerHeadroom = new Headroom(headroomEl, options)
        headerHeadroom.init();
        global.headerHeadroom = headerHeadroom;
    }

    // To-top button and Scroll down arrow
    const scrollDownArrow = $(".scroll-arrow");
    const toTopBtn = $('#to-top');
    $(window).scroll(function () {
        if ($(window).scrollTop() > 300) {
            scrollDownArrow.fadeOut(600);
            toTopBtn.fadeIn(300);
        } else {
            scrollDownArrow.fadeIn(600);
            toTopBtn.fadeOut(300);
        }
    });
    toTopBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 'slow');
    });
    scrollDownArrow.click(function (e) {
        e.preventDefault();
        let id = $(this).attr('data-scroll-to');
        let offsetTop = window.innerWidth >= 768 ? 80 : 0;
        $("html, body").animate({
            scrollTop: $('#' + id).offset().top - offsetTop
        }, "slow");
        $(this).mouseout();
    });


    // Burgermenu
    const burgerMenu = $('.burgermenu');
    const burgerMenuBack = $('.burgermenu-back');
    const headerMenu = $('.header__menu');

    burgerMenu.click(function (el) {
        el.preventDefault();
        headerMenu.addClass('show');
        headerMenuAnim();
        burgerMenuBack.addClass('open');
        $(this).addClass('open');
        $('body').addClass('overflow-y-hidden');
    })

    burgerMenuBack.click(function (el) {
        if (burgerMenuBack.hasClass("submenu-close")) {
            $("div[id*='menu']").removeClass("open");
            $(".header__logo-wrapper").removeClass("open");
            $(".header .main-burger-wrapper").removeClass("open");
            $(".burgermenu-back.open").removeClass("submenu-close");
            headerSubMenuAnimDesktop(true, 1.5, 0.09, ".submenu .nav-menu li");

        } else {
            el.preventDefault();
            $(this).removeClass('open');
            burgerMenu.removeClass('open');
            headerMenu.removeClass('show header__menu--transitionend');
            $('body').removeClass('overflow-y-hidden');
            headerMenuAnim(true);
        }
    })

    // Header Menu transition on show for mobile
    headerMenu.find('li').on('transitionend', () => {
        if (headerMenu.hasClass('show')) {
            headerMenu.addClass('header__menu--transitionend');
        }
    })

    function loadMasonry() {
        // Works Masonry layout
        var worksMasonry = document.querySelector('.works__masonry');
        var worksMasonryObj;
        if (worksMasonry) {
            Promise.all(Array.from(document.images).filter(img => !img.complete).map(img => new Promise(resolve => {
                img.onload = img.onerror = resolve;
            }))).then(() => {
                worksMasonryObj = new Masonry(worksMasonry, {
                    itemSelector: '.works__masonry-item',
                    columnWidth: '.works__masonry-sizer',
                    percentPosition: true,
                    horizontalOrder: true,
                });

                var count = 0;
                $(worksMasonry).imagesLoaded()
                    .progress(function (instance, image, i) {
                        count = count + 100;
                        setTimeout(function () {
                            image.img.style.transform = "translate3d(0,0,0)";
                            image.img.style.opacity = "1";
                        }, count);
                    });

                // $(worksMasonry).imagesLoaded().progress( function() {
                //     worksMasonry.masonry('layout');
                // });
            });
        }
    }

    loadMasonry();


    /* Animations */
    // AOS animations
    $(function () {
        AOS.init({
            duration: 700,
            offset: 50,
            once: true,
        });
    });

    // Gsap animations
    //gsap.registerPlugin(ScrollTrigger);
    var tlMenuItems = new gsap.timeline();
    var tlMenuSubItems = new gsap.timeline();
    // ScrollY element
    if ($('.tratti-scroll-y').length) {
        let trattiScrollY = gsap.to(".tratti-scroll-y", {
            scrollTrigger: {
                scrub: 1.5,
                start: "top",
                end: "bottom",
                ease: "expo.out",
            },
            y: "150px",
        });
    }

    // Tratti Bullet scroll
    let trattiBulletRosa = gsap.to(".tratti-bullet--rosa", {
        scrollTrigger: {
            scrub: 2,
            start: "300",
            end: "bottom+=300",
            ease: "expo.out",
        },
        y: "180%",
    });
    let trattiBulletRed = gsap.to(".tratti-bullet--red", {
        scrollTrigger: {
            scrub: 2,
            start: "300",
            end: "bottom+=300",
            ease: "expo.out",
        },
        y: "-180%",
    });

    // Delay view Tratti Bullet
    const trattiBullet = $(".tratti-bullet");
    setTimeout(delayTrattiBullet, 2000);

    function delayTrattiBullet() {
        trattiBullet.addClass('animate');
    }

    trattiBullet.on("animationend", function () {
        $(this).css('opacity', 1);
        $(this).removeClass('animate');
    });

    // Parallax sections with circle image/video
    let firstSectionParallax = $('.section-parallax__wrapper-first-el');
    if (firstSectionParallax.length) {
        $(window).scroll(function () {
            if ($(window).scrollTop() > 150) {
                firstSectionParallax.addClass('section-parallax__wrapper-first-el-scroll')
            } else {
                firstSectionParallax.removeClass('section-parallax__wrapper-first-el-scroll')
            }
        });
    }

    // Header Menu mobile items animation
    function headerMenuAnim(reverse = false, duration = 0.2, stagger = 0.1) {
        tlMenuItems.progress(0).clear();
        if (!reverse) {
            tlMenuItems.fromTo(".header__menu li",
                {
                    opacity: 0,
                    y: function (index, target, targets) {
                        return index * 50;
                    }
                },
                {
                    duration: duration,
                    stagger: stagger,
                    ease: "expo.out",
                    opacity: 1,
                    y: 0
                });
        }
    }


    function headerSubMenuAnimDesktop(reverse = false, duration = 0.65, stagger = 0.07, target = "") {
        tlMenuSubItems.progress(0).clear();
        if (!reverse) {
            tlMenuSubItems.fromTo(target,
                {
                    delay: 0,
                    y: function (index, target, targets) {
                        return index * 70;
                    }
                },
                {
                    delay: 0,
                    duration: duration,
                    stagger: stagger,
                    ease: "expo.out",
                    y: 0
                });
        }
    }

    /* END Animations */

    let plus = $('.accord-head .plus');

    plus.on('click', function () {
        if ($(this).hasClass('turned')) {
            $(this).removeClass('turned')
            $(this).parent().siblings(".accord-body").slideUp();
        } else {
            $(this).addClass('turned')
            $(this).parent().siblings(".accord-body").slideDown();
        }
    })

    let opener = $('.accord-head .cta-button--round');

    opener.on('click', function () {
        if ($(this).children('.big-plus').hasClass('turned')) {
            $(this).children('.big-plus').removeClass('turned')
            $(this).parent().siblings(".accord-body").slideUp();
        } else {
            $(this).children('.big-plus').addClass('turned')
            $(this).parent().siblings(".accord-body").slideDown();
        }
    })

    function openCloseSubMenu(link, linka, sub) {
        link.click(function (e) {
            e.preventDefault();
        })


        link.hover(function (e) {
            link.addClass("link-active");
            sub.stop().fadeIn(300);
            sub.addClass('open')
            $("header").toggleClass("headroom-open");
            e.stopPropagation()
        }, function (e) {
            sub.stop().fadeOut(300);
            sub.removeClass('open')
            link.removeClass("link-active");
            $("header").toggleClass("headroom-open");
            e.stopPropagation();
        });
        //
        sub.hover(function (e) {
            sub.stop().fadeIn(300);
            link.addClass("link-active");
            $("header").toggleClass("headroom-open");
            e.stopPropagation()
        }, function (e) {
            link.removeClass("link-active");
            sub.stop().fadeOut(300);
            $("header").toggleClass("headroom-open");
            e.stopPropagation()
        });
    }


    let contrMenuAgenzia = $("#menuAgenzia");
    let linkAgency = $(".agenzia-link");
    let linkAgencyA = $(".agenzia-link a");

    let contrMenuServizi = $("#menuServizi");
    let linkServizi = $(".servizi-link");
    let linkServiziA = $(".servizi-link a");

    let contrMenuEventi = $("#menuEventi");
    let linkEventi = $(".eventi-link");
    let linkEventiA = $(".eventi-link a");

    if (!isMobile()) {
        openCloseSubMenu(linkAgency, linkAgencyA, contrMenuAgenzia);
        openCloseSubMenu(linkServizi, linkServiziA, contrMenuServizi);
        openCloseSubMenu(linkEventi, linkEventiA, contrMenuEventi);
    }


    function handleHamburger() {
        $(".header__logo-wrapper").addClass("open");
        $(".header .overflow-x-hidden").addClass("open");
        $(".burgermenu-back.open").addClass("submenu-close");
    }

    if (!isMobile()) {
        $(".agenzia-link").hover(function () {
            headerSubMenuAnimDesktop(false, 0.6, 0.06, " .submenu .agenzia-menu li ");
            // $("#menuAgenzia").addClass("open");
            handleHamburger();
        }, function (e) {
            e.preventDefault();
            e.stopPropagation();
        });

    } else {
        $(".agenzia-link a").on("click", function () {
            headerSubMenuAnimDesktop(false, 1.5, 0.09, ".submenu .agenzia-menu li");
            $("#menuAgenzia").addClass("open");
            handleHamburger();
        })
    }


    if (!isMobile()) {
        $(".servizi-link").hover(function () {
            headerSubMenuAnimDesktop(false, 0.5, 0.05, " .submenu .servizi-menu li ");
            // $("#menuServizi").addClass("open");
            handleHamburger();
        }, function (e) {
            e.preventDefault();
            e.stopPropagation();
        });

    } else {
        $(".servizi-link a").on("click", function () {
            headerSubMenuAnimDesktop(false, 1.5, 0.09, ".submenu .servizi-menu li");
            $("#menuServizi").addClass("open");
            handleHamburger();
        })
    }


    if (!isMobile()) {
        $(".eventi-link").hover(function () {
            headerSubMenuAnimDesktop(false, 0.5, 0.05, " .submenu .eventi-menu li ");
            // $("#menuEventi").addClass("open");
            handleHamburger();
        }, function (e) {
            e.preventDefault();
            e.stopPropagation();
        });

    } else {
        $(".eventi-link a").on("click", function () {
            headerSubMenuAnimDesktop(false, 1.5, 0.1, ".submenu .eventi-menu li");
            $("#menuEventi").addClass("open");
            handleHamburger();
        })
    }


    $("li.menu-item:not([class*='link'])").mouseenter(function () {
        if (!isMobile()) {
            $(".header").addClass("color-bg-black-2");
            $(".menu-item span").addClass("text-white");
            $(".menu-item a").addClass("text-white");
            $(".menu-item").addClass("text-white");
        }

        $(".header").addClass("headroom-open");
    });

    $("li.menu-item:not([class*='link'])").mouseleave(function () {
        if (!isMobile()) {
            $(".header").removeClass("color-bg-black-2");
            $(".menu-item a").removeClass("text-white");
            $(".menu-item span").removeClass("text-white");
            $(".menu-item").removeClass("text-white");
        }

        $(".header").removeClass("headroom-open");
    });

    /* codice js per gestire i filtraggio di servizio/settore in pagina progetti/works */
    let filter_slug_sector = [];
    let filter_slug_service = [];
    let currency_slug = "";
    let find_slug_service = "";
    var find_slug;

    $(".filter-sector").on("click", function () {
        var curr_sector_clicked = $(this);

        $(".filter-sector").map(function (i, item) {
            if ($(item).attr("data-filter-sector") != curr_sector_clicked.attr("data-filter-sector")) {
                $(item).removeClass("active");
            }
        });

        $(".filter-service").map(function (i, item) {
            $(item).removeClass("active");
        });


        if (curr_sector_clicked.hasClass("active")) {
            currency_slug = "";
            curr_sector_clicked.removeClass("active");
        } else {
            curr_sector_clicked.addClass("active");
            currency_slug = curr_sector_clicked.attr("data-filter-sector");
        }
        // find_slug = filter_slug_sector.indexOf(currency_slug);
        // if (find_slug > -1) {
        //     filter_slug_sector.splice(find_slug, 1);
        // } else {
        //     filter_slug_sector.push(currency_slug);
        // }


        $.request('onFilterButton', {
            data: {'sectors': currency_slug},
            complete: function () {
                window.history.replaceState('', '', '/works');
                loadMasonry();
            },
            error: function (error) {
            }
        });
    });

    $(".filter-service").on("click", function () {
        var curr_service_clicked = $(this);

        $(".filter-service").map(function (i, item) {
            if ($(item).attr("data-filter-service") != curr_service_clicked.attr("data-filter-service")) {
                $(item).removeClass("active");
            }
        });

        $(".filter-sector").map(function (i, item) {
            $(item).removeClass("active");
        });


        if (curr_service_clicked.hasClass("active")) {
            currency_slug = "";
            curr_service_clicked.removeClass("active");
        } else {
            curr_service_clicked.addClass("active");
            currency_slug = curr_service_clicked.attr("data-filter-service");
        }

        // find_slug_service = filter_slug_service.indexOf(currency_slug);
        // if (find_slug_service > -1) {
        //     filter_slug_service.splice(find_slug_service, 1);
        // } else {
        //     filter_slug_service.push(currency_slug);
        // }

        $.request('onFilterButton', {
            data: {'services': currency_slug},
            complete: function (data) {
                window.history.replaceState('', '', '/works');
                loadMasonry();
            },
            error: function (error) {
            }
        });
    });

    $("#work-tab-list li").on("click", function () {
        $(".filter-service").map(function (i, item) {
            $(item).removeClass("active");
        });

        $(".filter-sector").map(function (i, item) {
            $(item).removeClass("active");
        });

        $.request('onFilterButton', {
            data: {},
            complete: function () {
                loadMasonry();
            },
            error: function (error) {
            }
        });
    });
    /* FINE codice js per gestire i filtraggio di servizio/settore in pagina progetti/works */

    /* codice gsap per l'effetto hover nella pagina Awards */
    const allVenues = gsap.utils.toArray(".list-premio");
    const venueImageWrap = document.querySelector(".venues-img-wrap");
    const venueImage = document.querySelector(".venues-img");
    const awardsContainer = document.querySelector(".awards-container");

    function initVenues() {
        allVenues.forEach((link, index) => {
            link.addEventListener("mouseenter", venueHover);
            link.addEventListener("mouseleave", venueHover);
            link.addEventListener("mousemove", moveVenueImage);
        });

        if (awardsContainer) {
            awardsContainer.addEventListener("mouseleave", function () {
                resetAwardsEffect(0);

            });

            awardsContainer.addEventListener("mouseenter", function () {
                resetAwardsEffect(1);
            });
        }
    }

    function resetAwardsEffect(opacity) {
        const tlAwards = gsap.timeline();
        const tlSingleAwards = gsap.timeline();
        tlAwards.to(venueImageWrap, {
            autoAlpha: opacity
        });

        tlSingleAwards.to(venueImage, {
            autoAlpha: opacity
        })
    }

    function moveVenueImage(e) {
        let xpos = e.pageX + 30;
        let ypos = e.pageY - 205;
        const tlAwards = gsap.timeline();
        tlAwards.to(venueImageWrap, {
            x: xpos,
            y: ypos
        });
    }


    function venueHover(e) {
        if (e.type === "mouseenter") {
            var first_target = $(e.target).hasClass("index-1");
            const targetImage = e.target.dataset.img;
            const tlSingleAwards = gsap.timeline();
            if (first_target) {
                tlSingleAwards.set(venueImage, {
                    backgroundImage: `url(${targetImage})`,
                }).from(venueImageWrap, {
                    x: e.pageX,
                    y: e.pageY
                }).to(venueImageWrap, {
                    duration: 0.5,
                    autoAlpha: 1
                });
            } else {
                tlSingleAwards.set(venueImage, {
                    backgroundImage: `url(${targetImage})`,
                }).to(venueImageWrap, {
                    duration: 0.5,
                    autoAlpha: 1
                });
            }


        } else if (e.type === "mouseleave") {
            const tlAwards = gsap.timeline();
            tlAwards.to(venueImageWrap, {
                duration: 0.5,
                autoAlpha: 1
            });
        }
    }

    function init() {
        initVenues();
    }

    function isMobile() {
        const minWidth = 768; // Minimum width for desktop devices
        return window.innerWidth < minWidth || screen.width < minWidth;
    }


    if (!isMobile()) {
        init();
    }

    gsap.utils.toArray("[data-gsap-scroll-lines]").forEach((container) => {

        SplitText.create(container, {
            type: "words,lines",
            mask: "lines",
            linesClass: "line",
            autoSplit: true,
            onSplit: (instance) => {
                return gsap.from(instance.lines, {
                    y: 80,
                    stagger: 0.15,
                    scrollTrigger: {
                        // markers:true,
                        trigger: container,
                        scrub: 2,
                        start: "clamp(top 90%)",
                        end: "clamp(bottom 0%)"
                    }
                });
            }
        });
    });

    gsap.utils.toArray("[data-gsap-title]").forEach((container) => {
        const isHero = container.closest(".intro-home, .hero, [data-gsap-hero]") !== null;
        const delay = parseFloat(container.dataset.gsapDelay) || 0;

        SplitText.create(container, {
            type: "lines",
            mask: "lines",
            linesClass: "line-gsap",
            autoSplit: true,
            onSplit: (instance) => {
                gsap.set(container, {autoAlpha: 1});

                const tlVars = isHero
                    ? {delay: delay || 0.5}
                    : {
                        delay,
                        scrollTrigger: {trigger: container, start: "top 80%", toggleActions: "play none none none"}
                    };
                const tl = gsap.timeline(tlVars);

                tl.from(instance.lines, {
                    duration: 1.2,
                    skewX: 45,
                    yPercent: 102,
                    ease: "power3.out",
                    stagger: {amount: 0.5, from: "center"},
                    onComplete: () => {
                        instance.lines.forEach((line) => {
                            const mask = line.parentElement;
                            if (mask) {
                                gsap.set(mask, {overflow: "visible"});
                            }
                        });
                    },
                });

                return tl;
            },
        });
    });

    gsap.utils.toArray("[data-gsap-fade]").forEach((element, i) => {
        const delay = parseFloat(element.dataset.gsapDelay) || i * 0.1;

        const anim = gsap.fromTo(
            element,
            {
                autoAlpha: 0,
                y: 10,
            },
            {
                duration: 1.1,
                autoAlpha: 1,
                y: 0,
                delay,
                ease: "power3.out",
            }
        );

        ScrollTrigger.create({
            trigger: element,
            animation: anim,
            start: "top 85%",
            toggleActions: "play none none none",
            once: true,
        });
    });

    gsap.utils.toArray("[data-gsap-fade-words]").forEach((container) => {
        const delay = parseFloat(container.dataset.gsapDelay) || 0;
        SplitText.create(container, {
            type: "words",
            mask: "words",
            wordsClass: "word-gsap",
            autoSplit: true,
            onSplit: (instance) => {
                gsap.set(container, {autoAlpha: 1});
                return gsap.from(instance.words, {
                    duration: 0.8,
                    autoAlpha: 0,
                    yPercent: 60,
                    ease: "power3.out",
                    stagger: 0.08,
                    delay,
                    scrollTrigger: {
                        trigger: container,
                        start: "top 85%",
                        toggleActions: "play none none none",
                    },
                });
            },
        });
    });

    gsap.utils.toArray("[data-gsap-fade-lines]").forEach((container) => {
        const delay = parseFloat(container.dataset.gsapDelay) || 0;
        SplitText.create(container, {
            type: "words,lines",
            mask: "lines",
            linesClass: "line",
            autoSplit: true,
            onSplit: (instance) => {
                gsap.set(container, {autoAlpha: 1});
                return gsap.from(instance.lines, {
                    duration: 0.4,
                    autoAlpha: 0,
                    yPercent: 60,
                    ease: "power3.out",
                    stagger: 0.1,
                    delay,
                    scrollTrigger: {
                        trigger: container,
                        start: "top 90%",
                        toggleActions: "play none none none",
                    },
                });
            },
        });
    });

    gsap.utils.toArray("[data-gsap-title-reveal]").forEach((container) => {
        const delay = parseFloat(container.dataset.gsapDelay) || 0;
        SplitText.create(container, {
            type: "lines",
            mask: "lines",
            linesClass: "line",
            autoSplit: true,
            onSplit: (instance) => {
                gsap.set(container, {autoAlpha: 1});
                const tl = gsap.timeline({
                    delay,
                    scrollTrigger: {
                        trigger: container,
                        start: "top 85%",
                        toggleActions: "play none none none",
                    },
                });
                tl.from(instance.lines, {
                    duration: 1.2,
                    y: 150,
                    autoAlpha: 0,
                    ease: "power3.out",
                    stagger: 0.20,
                });
                return tl;
            },
        });
    });

    gsap.utils.toArray("[data-gsap-scroll-lines]").forEach((container) => {
        SplitText.create(container, {
            type: "words,lines",
            mask: "lines",
            linesClass: "line",
            autoSplit: true,
            onSplit: (instance) => {
                gsap.set(container, {autoAlpha: 1});
                return gsap.from(instance.lines, {
                    y: 18,
                    autoAlpha: 0,
                    stagger: 0.1,
                    scrollTrigger: {
                        trigger: container,
                        scrub: 1,
                        start: "clamp(top 60%)",
                        end: "clamp(bottom 60%)",
                    },
                });
            },
        });
    });

    (function heartAnimation() {
        const xmlns = "http://www.w3.org/2000/svg";
        const xlinkns = "http://www.w3.org/1999/xlink";

        gsap.registerPlugin(Physics2DPlugin);

        const pContainer = document.querySelector('.pContainer');
        const heartSVG = document.querySelector('.heartSVG');
        const isDevice = /android|webos|iphone|ipad|ipod|blackberry/i.test(navigator.userAgent.toLowerCase());

        const heartPool = isDevice ? 80 : 200;
        const heartPoolArray = [];
        const numHearts = isDevice ? 10 : 25;
        let heartCount = 0;
        const step = 360 / numHearts;
        let destParticle;

        function randomBetween(min, max) {
            return Math.floor(Math.random() * (max - min + 1) + min);
        }

        function resetParticle(p) {
            gsap.set(p, {
                scale: 2,
                transformOrigin: '50% 50%',
                x: -100,
                y: -100,
                opacity: 1,
                fill: '#db3434'
            });
        }

        function createHeartPool() {
            let i = heartPool;
            while (--i > -1) {
                const p = document.createElementNS(xmlns, 'use');
                pContainer.appendChild(p);
                destParticle = '#heart';
                p.setAttributeNS(xlinkns, 'xlink:href', destParticle);
                // p.setAttribute('fill', '#db3434');
                p.setAttribute('stroke', '#DD1629');
                resetParticle(p);
                heartPoolArray.push(p);
            }
        }

        function createExplosion(x, y) {
            const max = heartCount + numHearts;
            for (let i = heartCount; i < max; i++) {
                const p = heartPoolArray[i];
                const localCount = i % numHearts;
                const deg = (step * localCount);

                gsap.set(p, { x, y, rotation: deg - 90 });

                gsap.to(p, {
                    duration: 2,
                    physics2D: {
                        gravity: 0,
                        velocity: 300,
                        angle: deg
                    },
                    fill: '#DD1629',
                    opacity: 0.6,
                    ease: "expo.inOut",
                    scale: 0,
                    onComplete: resetParticle,
                    onCompleteParams: [p]
                });

                heartCount++;
            }
            if (heartCount + numHearts >= heartPool) heartCount = 0;
        }

        function createHeartRing(x, y) {
            gsap.set(heartSVG, { visibility: 'visible' });

            const h = document.createElementNS(xmlns, 'use');
            const d = document.createElementNS(xmlns, 'use');
            pContainer.appendChild(h);
            pContainer.appendChild(d);

            h.setAttributeNS(xlinkns, 'xlink:href', '#heart');
            h.setAttribute('fill', '#FFF');
            d.setAttributeNS(xlinkns, 'xlink:href', '#ring');
            // d.setAttribute('stroke', '#DD1629');
            // d.setAttribute('stroke-width', '2');

            gsap.set([h, d], {
                scale: 0.7,
                transformOrigin: '50% 50%',
                x,
                y,
                fill: '#db3434'
            });

            gsap.to(h, {
                duration: 4,
                opacity: 0,
                fill: '#000',
                scale: 10,
                ease: "back.out",
                onComplete() { h.remove(); }
            });

            gsap.to(d, {
                duration: 0.5,
                opacity: 0,
                scale: 0,
                stroke: '#ef2341',
                strokeWidth: 1,
                ease: "back.in(3)",
                onComplete() {
                    d.remove();
                    createExplosion(x, y);
                }
            });
        }

        function toSVGCoords(screenX, screenY) {
            const pt = heartSVG.createSVGPoint();
            pt.x = screenX;
            pt.y = screenY;
            return pt.matrixTransform(heartSVG.getScreenCTM().inverse());
        }

        createHeartPool();

        document.querySelectorAll('.logo_anniversary, .logo_chi-ci-conosce').forEach(logo => {
            logo.addEventListener('click', (e) => {
                e.stopPropagation();
                const rect = logo.getBoundingClientRect();
                const svgPt = toSVGCoords(rect.left + rect.width / 2, rect.top + rect.height / 2);
                createHeartRing(svgPt.x, svgPt.y);
            });

            if (isDevice) {
                logo.addEventListener('touchstart', (e) => {
                    e.stopPropagation();
                    const touch = e.touches[0];
                    const svgPt = toSVGCoords(touch.clientX, touch.clientY);
                    createHeartRing(svgPt.x, svgPt.y);
                });
            }
        });

        function autoExplosion() {
            const svgPt = toSVGCoords(randomBetween(10, window.innerWidth), randomBetween(10, window.innerHeight));
            createHeartRing(svgPt.x, svgPt.y);
            gsap.delayedCall(0.1666, autoExplosion);
        }

    }());

});


